import { type PairedFieldItem, WordItem } from '@qai/ui';

export interface ChangeDetectionResult {
  hasDeletion: boolean;
  hasCompleteNewItem: boolean;
  hasUpdatedItem: boolean;
  hasMeaningfulChange: boolean;
}

export function detectWordItemChanges(
  previous: WordItem[],
  current: WordItem[]
): ChangeDetectionResult {
  const hasDeletion = previous.some(
    (prev) => prev.uuid && !current.some((curr) => curr.uuid === prev.uuid)
  );
  const hasCompleteNewItem = current.some(
    (curr) => !curr.uuid && curr.value?.trim()
  );
  const hasUpdatedItem = current.some(
    (curr) =>
      curr.uuid &&
      previous.some(
        (prev) =>
          prev.uuid === curr.uuid && prev.value?.trim() !== curr.value?.trim()
      )
  );
  return {
    hasDeletion,
    hasCompleteNewItem,
    hasUpdatedItem,
    hasMeaningfulChange: hasDeletion || hasCompleteNewItem || hasUpdatedItem,
  };
}

export function detectPairedFieldChanges(
  previous: PairedFieldItem[],
  current: PairedFieldItem[]
): ChangeDetectionResult {
  const hasDeletion = previous.some(
    (prev) => prev.uuid && !current.some((curr) => curr.uuid === prev.uuid)
  );
  const hasCompleteNewItem = current.some(
    (curr) => !curr.uuid && curr.key?.trim() && curr.value?.trim()
  );
  const hasUpdatedItem = current.some(
    (curr) =>
      curr.uuid &&
      previous.some(
        (prev) =>
          prev.uuid === curr.uuid &&
          (prev.key?.trim() !== curr.key?.trim() ||
            prev.value?.trim() !== curr.value?.trim())
      )
  );
  return {
    hasDeletion,
    hasCompleteNewItem,
    hasUpdatedItem,
    hasMeaningfulChange: hasDeletion || hasCompleteNewItem || hasUpdatedItem,
  };
}
